<template>
	<v-card>
		<v-card-title class="mt-3">
			<h1 class="ml-2">Karty umów dotacji</h1>
		</v-card-title>
		<v-container fluid>
			<v-layout>
				<v-flex xs12 sm6>
					<h2>Karty umów</h2>
					<v-container fluid>
						<v-layout style="position: relative">
							<v-flex ma-3 xs6>
								<v-select
									:items="templates"
									item-text="name"
									v-model="selectedTemplate"
									item-value="id"
									aria-label="template"
									return-object
									:disabled="!possibleToGenerateAgreement()"
								></v-select>
							</v-flex>
							<v-flex ml-5>
								<v-btn @click="getAgreement" :disabled="!possibleToGenerateAgreement()"
									style="float: left; margin-top: 13px;">
									Generuj kartę
								</v-btn>
							</v-flex>
						</v-layout>
					</v-container>
				</v-flex>
				<v-flex xs12 sm6>
					<project-file-view
						button-label="Dodaj kartę umowy dotacji"
						files-label="Dodane karty:"
						:load-files="loadFiles"
						upload-endpoint="/project/donation-contract"
						:disable-file-input="!possibleToGenerateAgreement()"
						:delete-function="deleteFile"/>
				</v-flex>
			</v-layout>
			<v-layout><h3>Uwagi</h3></v-layout>
			<v-layout>
				<v-flex>
					<v-textarea outline auto-grow v-model="project.donationContractRemarks"
						browser-autocomplete="off" aria-label="donation contract remarks"></v-textarea>
				</v-flex>
			</v-layout>
			<v-btn primary @click="saveProjectDonationContractRemarks">Zapisz</v-btn>
		</v-container>
	</v-card>
</template>

<script>
	import {Department} from "../../../api/generated/Department";
	import {Files} from "../../../utils/Files";
	import ProjectFileView from "./components/ProjectFileView";
	import {Project} from "../../../api/generated/Project";

	export default {
		name: "ProjectDonationContractView",
		components: {ProjectFileView},
		mixins: [Files],

		data() {
			return {
				templates: [],
				selectedTemplate: null,
				donationContractRemarks: ""
			};
		},

		methods: {
			getAgreement() {
				if (this.selectedTemplate) {
					this.downloadFileAsBlob(this, this.generateDonationContract(this.$route.params.projectId, this.selectedTemplate.id), this.selectedTemplate.name);
				}
			},

			possibleToGenerateAgreement() {
				//Możliwość wygenerowania karty umowy dotacji powinna być odblokowywana przez załączenie umowy
				return this.project.agreementNumber !== null && this.project.agreementSignDate !== null;
			},
			loadFiles(ctx) {
				return Project.getDonationContract(ctx, this.$route.params.projectId, onSuccess => {
					ctx.uploadedFiles = onSuccess;
				});
			},
			deleteFile(ctx, fileHash) {
				Project.deleteDonationContract(ctx, this.$route.params.projectId, fileHash,
					onSuccess => {
						ctx.$messagesBus.$emit("success", "Dokument został usunięty");
						ctx.refresh();
					},
					onerror => {
						ctx.$messagesBus.$emit("error", "Nie udało się usunąć dokumentu");
					});
			},
			saveProjectDonationContractRemarks() {
				Project.putDonationContractRemarks(this, this.$route.params.projectId, {body: this.project.donationContractRemarks});
			}
		},

		props: {
			project: {
				type: Object
			},
		},

		mounted () {
			Department.getDonationContractTemplates(this, this.$route.params.contestId, success => {
				this.templates = success;
			});
		},
	};
</script>

<style scoped>

</style>
